// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const pa: ChromeTranslations = {
  'nav.nextPage': 'ਅਗਲਾ ਪੰਨਾ →',
  'nav.previousPage': '← ਪਿਛਲਾ ਪੰਨਾ',
  'nav.continueToLevel': 'ਪੱਧਰ ਵੱਲ ਜਾਰੀ ਰੱਖੋ →',
  'nav.backToMenu': 'ਮੀਨੂ ਵੱਲ ਵਾਪਸ →',
  'howto.page': '{total} ਵਿੱਚੋਂ ਪੰਨਾ {n}',
  'options.title': 'ਵਿਕਲਪ',
  'ui.language': 'ਭਾਸ਼ਾ',
};
